import { ApiListItem, WorkerAbsences } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for Absences of a Worker
 */
export class Absences extends CrudApiBase<WorkerAbsences, ApiListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/absences";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(employmentId?: string, workerId?: string): WorkerAbsences {
    return {
      employmentId: employmentId ?? "",
      workerId,
      periods: [],
    };
  }

  /**
   * Gets all the Worker absences objects of specified year.
   * @returns A Promise with result data: The full absences objects.
   */
  public getLatest(): Promise<WorkerAbsences[]> {
    return this.ajax.getJSON(`${this.baseUrl}/latest`);
  }

  /**
   * Gets the Absences for a specific employment relation.
   * @param employmentId Identifier for the Employment relation.
   * @returns A Promise with Absences.
   */
  public getForEmployment(employmentId: string): Promise<WorkerAbsences> {
    return this.ajax.getJSON(`${this.baseUrl}/employment/${employmentId}`) as Promise<WorkerAbsences>;
  }

  /**
   * Gets the Absences for the given employment relations.
   * @param employmentIds Identifiers for the Employment relations.
   * @returns A Promise with result data array.
   */
  public getForEmployments(employmentIds: string[]): Promise<WorkerAbsences[]> {
    if (employmentIds.length === 0) {
      return Promise.resolve([]);
    }
    let method = `${this.baseUrl}/employment/set?`;
    employmentIds.forEach((x) => { method += "employmentIds=" + encodeURIComponent("" + x) + "&"; });
    method = method.replace(/[?&]$/, "");
    return this.ajax.getJSON(method);
  }
}
